import React from "react";

const VARIANTS = {
  primary:
    "bg-primary text-stone-50 hover:bg-primary-700 focus-visible:outline-primary",
  secondary:
    "bg-secondary text-stone-50 hover:bg-secondary-700 focus-visible:outline-secondary",
  accent:
    "bg-accent text-primary-900 hover:bg-accent-600 focus-visible:outline-accent-700",
  outline:
    "border border-primary text-primary hover:bg-primary hover:text-white focus-visible:outline-primary",
  outlineLight:
    "border border-stone-50/50 text-stone-50 hover:border-stone-50 hover:bg-stone-50/10 focus-visible:outline-stone-50",
  ghost:
    "bg-white/10 text-white hover:bg-white/20 focus-visible:outline-white",
};

const Button = ({
  as: Component = "button",
  variant = "primary",
  block = false,
  className = "",
  children,
  ...props
}) => {
  return (
    <Component
      className={`inline-flex cursor-pointer items-center justify-center gap-2 rounded-sm px-6 py-3 text-xs font-semibold uppercase tracking-wider transition-all duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
        block ? "w-full" : ""
      } ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Button;
